const common = {
  "nav.about": "Om oss",
  "nav.approach": "V\u00e5r tiln\u00e6rming",
  "nav.contact": "Kontakt",
  "nav.getInTouch": "Ta kontakt",

  "hero.badge": "Norge \u00b7 Helsevesen",
  "hero.title1": "Moderne helsevesen,",
  "hero.title2": "levert med omsorg",
  "hero.description": "ExoMed tilbyr moderne medisinske tjenester med fokus p\u00e5 kvalitet, tilgjengelighet og pasientsentrert omsorg.",
  "hero.learnMore": "Les mer",
  "hero.contactUs": "Kontakt oss",
  "hero.scroll": "Rull ned",

  "about.badge": "Om ExoMed",
  "about.title1": "En ny standard",
  "about.title2": "innen medisinsk omsorg",
  "about.p1": "ExoMed ble grunnlagt p\u00e5 troen om at h\u00f8ykvalitets medisinske tjenester skal v\u00e6re tilgjengelige, tydelige og dypt menneskelige. Vi kombinerer klinisk kompetanse med en moderne, pasientorientert filosofi.",
  "about.p2": "Teamet v\u00e5rt er forpliktet til \u00e5 levere omsorg som ikke bare er medisinsk forsvarlig, men ogs\u00e5 respektfull, tilgjengelig og tilpasset hvert enkelt individ. Vi mener at tillit bygges gjennom konsekvens, \u00e6rlighet og genuin oppmerksomhet til hver pasient.",
  "about.value1Title": "Pasientsentrert",
  "about.value1Desc": "Hver beslutning vi tar starter med pasienten. Vi bygger omsorgsmodeller rundt individuelle behov og velvære.",
  "about.value2Title": "Kvalitet og tillit",
  "about.value2Desc": "Vi opprettholder de h\u00f8yeste standarder for klinisk kvalitet, \u00e5penhet og faglig integritet.",
  "about.value3Title": "Tilgjengelig omsorg",
  "about.value3Desc": "Vi mener at moderne medisinske tjenester skal v\u00e6re lette \u00e5 n\u00e5, lette \u00e5 forst\u00e5 og lette \u00e5 stole p\u00e5.",

  "tagline.badge": "V\u00e5r filosofi",
  "tagline.quote1": "\u00abModerne helsevesen,",
  "tagline.quote2": "levert med omsorg.\u00bb",
  "tagline.description": "Vi drives av en enkel id\u00e9: at alle fortjener tilgang til medisinsk omsorg som er vennlig, tydelig og konsekvent utmerket.",
  "tagline.quality": "Kvalitet",
  "tagline.qualitySub": "ved hvert skritt",
  "tagline.accessible": "Tilgjengelig",
  "tagline.accessibleSub": "for alle",
  "tagline.human": "Menneskelig",
  "tagline.humanSub": "alltid",

  "contact.badge": "Kontakt",
  "contact.title1": "Vi vil gjerne",
  "contact.title2": "h\u00f8re fra deg",
  "contact.description": "Har du et sp\u00f8rsm\u00e5l eller \u00f8nsker \u00e5 l\u00e6re mer om ExoMed? Ta kontakt med oss \u2014 vi svarer p\u00e5 alle henvendelser raskt og med omsorg.",
  "contact.emailLabel": "E-post",
  "contact.phoneLabel": "Telefon",
  "contact.firstName": "Fornavn",
  "contact.lastName": "Etternavn",
  "contact.emailAddr": "E-postadresse",
  "contact.subject": "Emne",
  "contact.message": "Melding",
  "contact.send": "Send melding",
  "contact.sending": "Sender...",
  "contact.successTitle": "Melding sendt",
  "contact.successDesc": "Takk for at du tok kontakt. Vi kommer tilbake til deg snart.",
  "contact.sendAnother": "Send en til",
  "contact.errorMsg": "Noe gikk galt. Pr\u00f8v igjen eller send oss en e-post direkte.",
  "contact.charLimit": "Meldingen kan ikke overstige 500 tegn.",

  "footer.description": "Moderne medisinske tjenester med fokus p\u00e5 kvalitet, tilgjengelighet og pasientsentrert omsorg.",
  "footer.navigation": "Navigasjon",
  "footer.navAbout": "Om oss",
  "footer.navApproach": "V\u00e5r tiln\u00e6rming",
  "footer.navContact": "Kontakt",
  "footer.contactTitle": "Kontakt",
  "footer.rights": "ExoMed. Alle rettigheter forbeholdt.",
  "footer.tagline": "Norge \u00b7 Moderne helsevesen",
  "footer.privacy": "Personvern",

  "personvern.backToHome": "Tilbake til hjem",
  "personvern.legal": "ExoMed \u00b7 Juridisk",
  "personvern.title": "Personvernerl\u00e6ring",
  "personvern.subtitle": "Denne erkl\u00e6ringen beskriver hvordan ExoMed behandler personopplysninger i samsvar med EUs personvernforordning (GDPR) og norsk personopplysningslov.",
  "personvern.lastUpdated": "Sist oppdatert:",
  "personvern.contents": "Innhold",
  "personvern.contactQ": "Sp\u00f8rsm\u00e5l om personvern?",
  "personvern.contactD": "Ta gjerne kontakt med oss dersom du har sp\u00f8rsm\u00e5l om hvordan vi behandler dine personopplysninger, eller \u00f8nsker \u00e5 benytte deg av dine rettigheter.",
};

export default common;
